import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { PackageTypeType } from '../../../api/package-type';

export type TypeTabPropsType = {
  packageTypes: PackageTypeType[];
};

function TypeTab({ packageTypes }: TypeTabPropsType) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const typeId = parseInt(params.get('type') || '0');

  const handleChange = (selectedTypeId: number | null) => {
    if (selectedTypeId && selectedTypeId !== typeId) {
      params.delete('package');
      params.delete('comprehensive');
      params.delete('free');
      params.delete('number');
      params.set('type', selectedTypeId.toString());
      if (selectedTypeId === 1) params.set('comprehensive', '0');
      else params.set('package', '1');
    }
    navigate(`${location.pathname}?${params}`);
  };

  return (
    <div className='mx-auto my-4 flex w-full max-w-sm items-center gap-3 sm:px-0'>
      <div className='flex flex-1 gap-1 space-x-0.5 rounded-xl bg-gray-200 p-1'>
        {packageTypes.map(packageType => (
          <button
            key={packageType.id}
            onClick={() => handleChange(packageType.id)}
            className={classNames(
              'w-full rounded-lg py-2 text-xs font-medium leading-5 text-gray-800 xs:text-sm',
              'ring-white ring-opacity-60 ring-offset-2 ring-offset-gray-600 focus:outline-none',
              packageType.id === typeId
                ? 'bg-white shadow focus:ring-2'
                : 'text-gray-200 hover:bg-white/[0.12] hover:text-white'
            )}
          >
            {packageType.shortName}
          </button>
        ))}
      </div>
    </div>
  );
}

export default TypeTab;
